import jwtDecode from 'jwt-decode';

/** The workspace an AMS access token is bound to (its `workspaceId` claim), or undefined if unreadable. */
export const workspaceCodeOf = (token: string | null | undefined): string | undefined => {
  if (!token) {
    return undefined;
  }
  try {
    const { workspaceId } = jwtDecode<{ workspaceId?: unknown }>(token);
    return typeof workspaceId === 'string' ? workspaceId : undefined;
  } catch {
    return undefined;
  }
};
